<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div
      class="boss-main-wrap boss-main-content-wrap pega-auto-reply-container"
    >
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="閲覧制限用IPアドレス設定"
      />
      <div class="grid-x align-justify">
        <div class="medium-8 cell">
          <h3 class="boss-joboffer-title boss-setting">
            閲覧制限の設定(IPアドレスは３０個まで)
          </h3>
        </div>
        <div class="medium-4 cell">
          <div class="float-right grid-x">
            <span
              v-tooltip="{ content: isOverLengthIpAddresses() ? 'IPアドレスは30件までしか登録できません。' : '' }"
              :disabled="isOverLengthIpAddresses()"
              class="boss-button pega-button boss-button-compact"
              data-test="add-ip-address-button"
              @click="addIpAddress()"
            >
              <span class="boss-icon-new" />
              <span class="boss-button-new-text">IPアドレスを追加</span>
            </span>
          </div>
        </div>
      </div>
      <div class="boss-table-2">
        <template-form
          v-for="(_, index) in ipAddresses"
          :key="index"
          :label="(index + 1) | label"
        >
          <div class="pega-relative">
            <div class="pega-width-40">
              <div>
                <small>※半角15文字以内</small>
              </div>
              <input
                v-model="ipAddresses[index]"
                maxlength="15"
                class="boss-input"
                type="text"
                :data-test="`ip-address-input${index}`"
              >
              <span
                v-if="!isIpAddressFormat(ipAddresses[index])"
                style="margin: 0"
                class="form-error is-visible"
                :data-test="`invalid-ip-address-input${index}`"
              >IPアドレスの形式に沿って入力してください。<br>（例）198.51.100.0</span>
            </div>
          </div>
        </template-form>
      </div>
      <div class="margin-top-1 pega-flex-center">
        <button
          :disabled="isDisabledRegisterButton"
          class="boss-button boss-button-confirm pega-button"
          data-test="register-button"
          @click="registerIpAddresses()"
        >
          <span class="boss-button-confirm-text">設定する</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import TemplateForm from '@/components/atoms/TemplateForm'
import _ from 'lodash'
import util from '@/lib/util.js'

export default {
  filters: {
    label (index) {
      return `IPアドレス[${index}]`
    }
  },
  components: {
    SettingHeader,
    TemplateForm
  },
  data () {
    return {
      ipAddresses: []
    }
  },
  computed: {
    requestParam () {
      return this.ipAddresses.filter(ipAddress => !_.isEmpty(ipAddress))
    },
    isIpAddressFormat () {
      return (val) => {
        return _.isEmpty(val) || util.isIpAddressFormat(val)
      }
    },
    isDisabledRegisterButton () {
      return this.ipAddressesInvalid()
    }
  },
  created () {
    this.fetchIpAddresses()
  },
  methods: {
    fetchIpAddresses () {
      this.$http.secured.get('/admin/settings/allowed_ip').then(response => {
        this.$set(this, 'ipAddresses', response.data)
        this.addIpAddress()
      })
    },
    addIpAddress () {
      if (this.isOverLengthIpAddresses()) {
        return
      }
      this.ipAddresses.push('')
    },
    registerIpAddresses () {
      this.$http.secured.post('/admin/settings/allowed_ip', this.requestParam).then(response => {
        this.$toasted.global.success({ message: '閲覧制限を設定しました。' })
        this.$router.push({ name: 'dashboardTop' })
      })
    },
    isOverLengthIpAddresses () {
      return this.ipAddresses.length >= 30
    },
    ipAddressesInvalid () {
      return !!(_.find(this.requestParam, ipAddress => !this.isIpAddressFormat(ipAddress)))
    }
  }
}
</script>
